import React from 'react';
import { Trans } from 'react-i18next';
import commonRoutes from '../../../routes/common';
import Link from '../../atoms/Link';
import { useTranslate } from '../../../translate/I18n';
import Box from '../../atoms/Box';
import { translateRoute } from '../../../routesActions/routeHelper';

const DisclaimerText = () => {
  const { t, i18n } = useTranslate(['auth']);
  return (
    <Trans i18nKey="auth:disclaimerLinks" i18n={i18n}>
      <Box mt={4} mb={6}>
        __text_part_1__
        <Link type="tertiary" to={translateRoute(commonRoutes.legal.privacyPolicy.to, 'en', i18n.language)} inNewWindow>
          {t(commonRoutes.legal.privacyPolicy.label)}
        </Link>
        __text_part_2__
        <Link type="tertiary" to={translateRoute(commonRoutes.legal.legalCenter.to, 'en', i18n.language)} inNewWindow>
          {t(commonRoutes.legal.legalCenter.label)}
        </Link>
        __text_part_3__
      </Box>
    </Trans>
  );
};

export default DisclaimerText;
